import AddUserForm from "../../forms/AddUserForm/AddUserForm";
import useGroupsAndDepartments from "../../hooks/useGroupsAndDepartments/useGroupsAndDepartments";
import { useNavigate } from "react-router-dom";
import {
  errorNotifications,
  successNotifications,
} from "../../../../utils/handleNotifications";
import { USERCREATE_API } from "../../../../api/endpoints";
import { addUserOptions } from "../../helpers/userSWROptions";

import useSWR from "swr";
import { fetcher } from "../../../../services/fetcher";

const AddUsersPage = () => {
  const navigate = useNavigate();
  const { mutate } = useSWR(USERCREATE_API, fetcher);
  const { fields, loadingFields } = useGroupsAndDepartments();

  const addUserMutation = async (newUser) => {
    try {
      await mutate(
        fetcher(`${USERCREATE_API}`, "POST", newUser),
        addUserOptions(newUser)
      );
      successNotifications("Success! User new item.");
      navigate(-1);
    } catch (err) {
      errorNotifications(err.response?.data, err);
    }
  };

  const handleSubmit = (payload) => {
    addUserMutation(payload);
  };

  return (
    <>
      <AddUserForm
        title="+ Add New Employee"
        groups={loadingFields ? [] : fields.roles}
        departments={loadingFields ? [] : fields.departments}
        onSubmit={handleSubmit}
      />
    </>
  );
};

export default AddUsersPage;